module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-riben.6268d31b.jpg";